import { Flex } from "@chakra-ui/react";
import { NavigationBlockerProvider } from "src/components/NavigationBlocker";
import { FormTemplateCard } from "./FormTemplateCard";
import { FormTemplateMetadata } from "./types/common";

interface Props {
  formTemplates: FormTemplateMetadata[];
}

export const FormTemplatesList: React.FC<Props> = ({ formTemplates }) => {
  return (
    <NavigationBlockerProvider>
      <Flex direction="column" gap={4}>
        {formTemplates.map((formTemplate) => (
          <FormTemplateCard key={formTemplate.id} formTemplate={formTemplate} />
        ))}
      </Flex>
    </NavigationBlockerProvider>
  );
};
